export default __webpack_public_path__ + "static/media/google.db01c681.svg";